import React, { Component } from "react";
import { Form, FormControl, FormGroup, Button } from "react-bootstrap";
import isNumeric from "validator/lib/isNumeric";
import toString from "lodash/toString";
import { isValidIndianMobileNo } from "../../../../../../util/utility";
import BasicLoader from "../../../../../../util/BasicLoader";

import styles from "../../../../../../styles/leadFormOtp.module.css";

const otpResendTime = 60;

class EventVerifyViaOTP extends Component {

constructor(props){
super(props);

this.state={
oldphone:this.props.phone,
userotp:"",
resendTime:otpResendTime
};

this.Interval=1000;
}

componentDidMount(){
if(this.props.isOTPSent){
this.handleResendTime();
}
}

componentWillUnmount(){
clearInterval(this.timer);
}

validatePhone=()=>{
if(!this.state.oldphone) return null;
return isValidIndianMobileNo(this.state.oldphone) ? "success":"error";
};

validateOTP=()=>{
if(!this.state.userotp) return null;
if(this.state.userotp.length===4 && isNumeric(this.state.userotp)){
return "success";
}
return "error";
};

handleOTPChange=(e)=>{
this.setState({userotp:e.target.value});
};

handleVerifyOTP=(e)=>{
e.preventDefault();

const otp=this.state.userotp;

if(!isNumeric(otp) || toString(otp).length!==4){
this.props.showMessage("Please enter proper otp","danger");
return;
}

this.props.verifyOTPCode(this.props.eventId,otp);
};

handleResendTime=()=>{
this.timer=setInterval(()=>{
if(this.state.resendTime>0){
this.setState({resendTime:this.state.resendTime-1});
}else{
clearInterval(this.timer);
}
},this.Interval);
};

handleResendOTP=()=>{
if(this.state.resendTime>0) return;

this.setState({resendTime:otpResendTime},()=>{
this.props.verifyEventByPhone(this.props.eventId,this.props.phone);
});
};

render(){

return(

<div className={styles.container}>

<Form onSubmit={this.handleVerifyOTP}>

<div className={styles.title}>
Verify Your Event
</div>

<div className={styles.subtitle}>
OTP sent to your mobile number
</div>

<div className={styles.edit}>
<span onClick={()=>this.props.editUserPhoneNumber()}>
Edit Number
</span>
</div>

<FormGroup className={styles.formGroup}>

<div className={styles.inputGroup}>

<div className={styles.countryCode}>
+91
</div>

<FormControl
type="text"
value={this.state.oldphone}
readOnly
className={`${styles.input} ${styles.phoneInput}`}
isValid={this.validatePhone()==="success"}
isInvalid={this.validatePhone()==="error"}
/>

</div>

</FormGroup>

<FormGroup className={styles.formGroup}>

<FormControl
type="text"
placeholder="Enter OTP"
value={this.state.userotp}
onChange={this.handleOTPChange}
className={styles.input}
isValid={this.validateOTP()==="success"}
isInvalid={this.validateOTP()==="error"}
/>

</FormGroup>

<button
className={styles.button}
disabled={this.props.isVerifyingOTP}
>

{this.props.isVerifyingOTP
? <BasicLoader color="#fff" size={10}/>
: "Verify"}

</button>

<div className={styles.resend}>

{this.state.resendTime>0
? <span>Resend in {this.state.resendTime}s</span>
:
<span
className={styles.link}
onClick={this.handleResendOTP}
>
Resend OTP
</span>
}

</div>

</Form>

</div>

);

}

}

export default EventVerifyViaOTP;